module.exports = __webpack_public_path__ + "media/images/icon-working-289384e4799ac44f251d331c77fe4d2e.svg";